<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-12 align-self-center">
      <h2>{{ $t("navigations.protocol extraction") }}</h2>
    </div>
  </div>

  <div class="wrapper wrapper-content px-0">
    <!-- SoA Extraction Card -->
    <div class="col-12 col-md-12 pl-0 pr-0">
      <div class="ibox mb-1">
        <div class="ibox-title style_2 d-flex justify-content-between align-items-center">
          <div>
            <h5 class="mb-0 mr-2">Protocol Extraction:</h5>
            <small>Upload the protocol document to automatically extract the Schedule of Activities (SoA), including visits, assessments, and study activities.</small>
          </div>
          <button class="btn btn-primary btn-sm py-0" type="button" @click="protocolextraction">
            <i class="fa fa-file-import me-2"></i> Import Protocol
          </button>
        </div>
      </div>
    </div>

    <!-- Extraction Data Table Card -->
    <div class="col-12 col-md-12 mt-1 pl-0 pr-0">
      <div class="ibox mb-2">
        <div class="ibox-title style_2 d-flex justify-content-between align-items-center">
          <h5 class="mb-0">Protocol List</h5>          
          <small v-if="extractionTotalCount">{{ extractionTotalCount }} records</small>
        </div>
        <div class="ibox-content p-2">
          <div class="text-center" v-if="extractiondataLoading === true">
            <img src="../../assets/img/loading.gif" width="15" alt="Loading" />
            <div>{{ $t("navigations.please wait while the list is being loaded") }}</div>
          </div>
          <template v-else>
            <div class="text-center" v-if="allextractiondata.length === 0">
              {{ $t('navigations.no data available') }}
            </div>
            <div v-else class="table-responsive table-container extraction-table-container">
              <table class="table table-striped table-bordered mb-0">
                <thead>
                  <tr>
                    <th>Protocol Name</th>
                    <th>Created At</th>
                    <th class="text-center">CTQ</th>
                    <th class="text-center">SoA</th>
                    <th class="text-center">Edit Check</th>
                    <th class="text-center">eCRF</th>
                    <th class="text-center">View</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in allextractiondata" :key="item.auditId">
                    <td class="wrap-text">{{ item.protocolName || '-' }}</td>
                    <td>{{ filterDate(item.createdAt) || '-' }}</td>
                    <td class="text-center">
                      <div v-if="isExtractionDownloadReady(item, 'ctq')" class="text-muted d-flex justify-content-center">
                        <div class="badge badge-success">{{ formatExtractionStatus(item.ctqStatus) }}</div>
                        <div class="mx-3">
                          <i class="fa me-1 text-primary cursorpointer"
                             @click="downloadExtractionDocument(item.ctqDocumentId, 'CTQ', item)"
                             :class="isExtractionDownloadLoading(item, 'ctq') ? 'fa-spinner fa-spin' : 'fa-download'"></i>
                        </div>
                      </div>
                      <span v-else-if="formatExtractionStatus(item.ctqStatus) != '-'" class="badge badge-warning">{{ formatExtractionStatus(item.ctqStatus) }}</span>
                      <span v-else>{{ formatExtractionStatus(item.ctqStatus) }}</span>
                    </td>
                    <td class="text-center">
                      <div v-if="isExtractionDownloadReady(item, 'soa')" class="text-muted d-flex justify-content-center">
                        <div class="badge badge-success">{{ formatExtractionStatus(item.soaStatus) }}</div>
                        <div class="mx-3">
                          <i class="fa me-1 text-primary cursorpointer"
                             @click="downloadExtractionDocument(item.soaDocumentId, 'SOA', item)"
                             :class="isExtractionDownloadLoading(item, 'soa') ? 'fa-spinner fa-spin' : 'fa-download'"></i>
                        </div>
                      </div>
                      <span v-else-if="formatExtractionStatus(item.soaStatus) != '-'" class="badge badge-warning">{{ formatExtractionStatus(item.soaStatus) }}</span>
                      <span v-else>{{ formatExtractionStatus(item.soaStatus) }}</span>
                    </td>
                    <td class="text-center">
                      <div v-if="isExtractionDownloadReady(item, 'editCheck')" class="text-muted d-flex justify-content-center">
                        <div class="badge badge-success">{{ formatExtractionStatus(item.editCheckStatus) }}</div>
                        <div class="mx-3">
                          <i class="fa me-1 text-primary cursorpointer"
                             @click="downloadExtractionDocument(item.editCheckDocumentId, 'Edit Check', item)"
                             :class="isExtractionDownloadLoading(item, 'editCheck') ? 'fa-spinner fa-spin' : 'fa-download'"></i>
                        </div>
                      </div>
                      <span v-else-if="formatExtractionStatus(item.editCheckStatus) != '-'" class="badge badge-warning">{{ formatExtractionStatus(item.editCheckStatus) }}</span>
                      <span v-else>{{ formatExtractionStatus(item.editCheckStatus) }}</span>
                    </td>
                    <td class="text-center">
                      <div v-if="isExtractionDownloadReady(item, 'ecrf')" class="text-muted d-flex justify-content-center">
                        <div class="badge badge-success">{{ formatExtractionStatus(item.ecrfStatus) }}</div>
                        <div class="mx-3">
                          <i class="fa me-1 text-primary cursorpointer"
                             @click="downloadExtractionDocument(item.ecrfDocumentId, 'ECRF', item)"
                             :class="isExtractionDownloadLoading(item, 'ecrf') ? 'fa-spinner fa-spin' : 'fa-download'"></i>
                        </div>
                      </div>
                      <span v-else-if="formatExtractionStatus(item.ecrfStatus) != '-'" class="badge badge-warning">{{ formatExtractionStatus(item.ecrfStatus) }}</span>
                      <span v-else>{{ formatExtractionStatus(item.ecrfStatus) }}</span>
                    </td>
                    <td class="text-center">
                      <i  class="fa fa-eye edit-delete"
                        @click="goToViewProtocol(item.protocolDocumentId)"></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-lg-12 d-flex justify-content-lg-end px-0 mt-2" v-if="allextractiondata.length !== 0">
              <v-pagination
                v-model="extractionCurrentPage"
                :pages="extractionTotalPages"
                :range-size="0"
                active-color="#f4f9ff"
                @update:modelValue="loadExtractionData"
              />
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>

  <!-- Protocol Extraction Modal -->
  <ProtocolExtraction
    v-if="protocolextractionpopup"
    @closemodel="colseprotocolextractinmodel"
  />
</template>
<script src="./SoAExtraction.js"></script>

<style scoped>
.ibox-title.style_2 {
  background-color: #f8f9fa;
  border-bottom: 1px solid #e7eaec;
  padding: 10px 15px;
}
.ibox-title h5{
    padding: 0 0 14px 0 !important;
}
.btn-primary {
  background-color: #1a6fc4;
  border-color: #1a6fc4;
}
.btn-primary:hover {
  background-color: #0e5a9c;
}
.cursorpointer {
  cursor: pointer;
}
.badge {
  padding-inline: 8px;
  padding-block: 2px;
}
.badge-success {
  background-color: #28a745;
  color: #ffffff;
}
.badge-warning {
  background-color: #ffc107;
  color: #212529;
}

/* Removed scroll styles – table expands fully without internal scrollbar */
.table-container {
  position: relative;
  /* no max-height, no overflow */
}
.extraction-table-container table {
  min-width: 880px;
}
.wrap-text {
  max-width: 50ch;
  white-space: normal;
  word-break: break-word;
}
.table th {
  background-color: #ffffff;
  font-weight: 600;
  color: #2c3e50;
  border-top: none;
  padding: 6px 16px;
  /* sticky header removed */
}
.table td {
  padding: 6px 16px;
  vertical-align: middle;
}
.table tr:hover {
  background-color: rgba(219, 234, 254, 0.3);
}

/* Optional: allow horizontal scroll on small screens without vertical scroll */
.table-responsive {
  overflow-x: auto;
  overflow-y: visible;
}

.mx-3 {
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
</style>
